<template>
  <div class="container" :class="{ 'container-img': !showShareBtn }" ref="box">
    <div class="nps-panel nps-top">
      <div class="top-info" v-if="plan.s_year">
        <div class="info-left">
          <div class="left-course">
            {{ ufrom == 'vip' ? '我' : plan.truename }}的第
            <span>{{ courses }}</span> 次训练计划
          </div>
          <div class="left-time">
            {{ plan.s_year + '.' + plan.s_month }}期训练
          </div>
        </div>
        <img
          class="info-img"
          v-if="showImg"
          @error="handelImgError"
          :src="
            plan.image
              ? plan.image
              : 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo'
          "
          alt
        />
      </div>
      <div class="currprogress-region">
        <div
          class="progress-pop"
          :style="courses ? 'left:' + currprogress : ''"
        >
          已完成
          <span>{{ currprogress }}</span>
          <div class="border-down-empty">
            <span></span>
          </div>
        </div>
        <div
          class="progress"
          :style="courses ? 'width:' + currprogress : ''"
        ></div>
      </div>
      <div class="progress-text">
        <span>已上课{{ plan.scan_class }}节</span>
        <span>总课时{{ plan.total_class || 12 }}节</span>
      </div>
    </div>
    <div class="nps-panel nps-position">
      <div class="position-title">本课时训练概述</div>
      <div class="position-item">
        训练部位：
        <span>{{ positionData.join('，') }}</span>
      </div>
      <gym-position
        :position="positionData"
        :gender="plan.gender == '男' ? '1' : '2'"
      ></gym-position>
      <div class="position-item position-item-1">
        训练模式
        <span>{{ plan.act_model }}</span>
      </div>
      <div class="position-item">
        训练目标
        <span>{{ plan.target }}</span>
      </div>
      <div class="position-item">
        热身组合
        <span>{{ plan.warm_up }}</span>
      </div>
    </div>
    <div class="nps-panel nps-act">
      <div class="act-title">动作组</div>
      <template v-if="plan.act_list_info && plan.act_list_info.length > 0">
        <div
          class="act-item"
          @click="onActItem(item)"
          v-for="(item, index) in plan.act_list_info"
          :key="index"
        >
          <div class="item-title">
            <div class="t-dot"></div>
            <div class="t-text">{{ item.a_name }}</div>
          </div>
          <div class="item-cent">
            <div class="cent-tag">
              {{ item.a_position.join(' ') }}，{{ item.appliance }}，
              <span class="cent-number"
                >{{ item.a_label.join(' ') }}， {{ item.a_level }}</span
              >
            </div>
            <div class="cent-desc">
              <span>{{ item.groups ? item.groups + '组' : '' }}，每组做</span
              ><span v-if="item.is_time">{{
                item.last_time ? item.last_time + '秒' : ''
              }}</span
              ><span v-if="!item.is_time">{{
                item.times ? item.times + '次' : ''
              }}</span
              ><span
                >，组间休息{{ item.second ? item.second + '秒' : '' }}</span
              >
              <template v-if="ufrom != 'vip'">
                <br />
                <span v-if="item.is_weight"
                  >重量：{{
                    item.weight
                      ? String(item.weight).replace('%1RM', '') + '%1RM'
                      : ''
                  }}</span
                >
                <span v-if="item.is_weight && item.actual"
                  >，实际重量:{{ item.actual ? item.actual + 'kg' : '' }}</span
                >
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="nps-panel nps-act">
      <div class="act-title">有氧训练</div>
      <div class="act-item" v-if="plan.aerobics_info">
        <div class="item-title">
          <div class="t-dot"></div>
          <div class="t-text">
            <span class="action">{{ plan.aerobics_info.action }}</span>
            <span class="sub-t">{{ plan.aerobics_info.level }}</span>
            <span class="sub-t">{{ plan.aerobics_info.times }}</span>
          </div>
        </div>
      </div>
      <div class="act-item">
        <div class="item-title">
          <div class="t-dot"></div>
          <div class="t-text">
            <span class="action">拉伸</span>
            <span class="sub-t">{{ plan.act_stretched }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-show="!showShareBtn">
      <canvas class="qr" id="qrCode-canvas"></canvas>
      <div class="f-right">
        <div class="f-text">长按识别二维码参与一对一私教训练</div>
        <img src="https://cdnvue.gymcity.com.cn/uploads/pub-caise-logo" alt />
      </div>
    </div>
    <!-- <footer class="footer-btn" @click="getImg" v-if="showShareBtn">
      {{ ufrom !== 'vip' ? '保存成图片' : '分享训练计划' }}
    </footer> -->
    <div
      @click="gtouchend()"
      :class="['share-img', showMask ? 'on-share-img' : '']"
      v-if
    >
      <img :src="imgUrl" alt />
    </div>
  </div>
</template>

<script>
import GymPosition from '@/components/GymPosition'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'

export default {
  components: {
    GymPosition
  },
  data() {
    return {
      showTips: false,
      imgUrl: null,
      showMask: false,
      showShareBtn: true,
      currprogress: '0%',
      plan: {
        truename: ' ',
        act_list_info: [],
        question: [],
        require: []
      },
      showImg: true,
      ufrom: this.$route.query.ufrom || 'vip'
    }
  },
  computed: {
    // 分享二维码链接
    qrcodeUrl() {
      return (
        location.href.split('#')[0] +
        `?path=acceptrecommend&fid=${this.$route.query.uid}&s_from=outplan`
      )
    },
    courses: function () {
      return Number(this.plan.id ? this.plan.id.slice(-2) : 0)
    },
    positionData: {
      get() {
        this.$forceUpdate()
        let temp = []
        if (this.plan.act_list_info.length >= 1) {
          this.plan.act_list_info.map((v) => {
            v.a_position.map((p) => {
              if (temp.indexOf(p) === -1) {
                temp.push(p)
              }
            })
          })
        }
        return temp
      },
      set() {}
    }
  },
  methods: {
    // 头像加载出错
    handelImgError() {
      this.showImg = false
    },
    // 点击某个动作
    onActItem(item) {},
    // 点击海报图片
    gtouchend() {
      this.showMask = false
      this.showShareBtn = true
    },
    getImg() {
      const that = this
      this.showShareBtn = false
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        // 合成分享图
        this.$toast.loading('正在生成图片...')
        let canvas = document.getElementById('qrCode-canvas')
        QRCode.toCanvas(canvas, this.qrcodeUrl, (error) => {
          if (error) {
            console.log(error)
          } else {
            // canvas.style.margin = '0'
            // canvas.style.height = '45'
            html2canvas(that.$refs.box, {
              backgroundColor: null,
              useCORS: true
            })
              .then(function (canvas) {
                that.imgUrl = canvas.toDataURL()
                // that.imgUrl = URL.createObjectURL(
                //   that.base64ToBlob(canvas.toDataURL())
                // );
                setTimeout(() => {
                  window.scrollTo(0, 0)
                  Indicator.close()
                  that.showMask = true
                  that.$toast({
                    message: '图片已生成，长按保存分享给你的好友吧',
                    position: 'middle',
                    duration: 3000
                  })
                  // setTimeout(() => {
                  //   // that.showShareBtn = true;
                  // }, 4000);
                }, 1500)
              })
              .catch((err) => {
                that.showShareBtn = true
              })
          }
        })
      })
    },
    getPlan() {
      this.$toast.loading('获取信息中')
      this.$http
        .get(
          'plan/outline',
          {
            a: 'planDetail',
            pid: this.$route.query.pid
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.plan = res.data.data || {}
            setTimeout(() => {
              this.currprogress =
                (
                  (this.plan.scan_class / (this.plan.total_class || 12)) *
                  100
                ).toFixed(0) + '%'
            }, 500)
            // 替换微信头像成服务器代理地址 预防生成图片跨域
            // this.plan.image = this.plan.image
            //   ? this.plan.image.replace(
            //       'http://thirdwx.qlogo.cn',
            //       location.origin + '/wechat_image'
            //     )
            //   : ''
            this.plan.date = this.plan.oid.split(':')[2]
            this.plan.s_year = this.plan.date.slice(0, 4)
            this.plan.s_month = this.plan.date.slice(4, 6)
            this.plan.s_day = this.plan.date.slice(6)
            this.plan.e_date = new Date(
              new Date(
                this.plan.s_year +
                  '/' +
                  this.plan.s_month +
                  '/' +
                  this.plan.s_day
              ).getTime() +
                30 * 24 * 60 * 60 * 1000
            )
            this.plan.e_year = this.plan.e_date.getFullYear()
            this.plan.e_month = this.plan.e_date.getMonth() + 1
            this.plan.e_day = this.plan.e_date.getDate()
            this.plan.e_day = String(this.plan.e_day)[1]
              ? this.plan.e_day
              : '0' + this.plan.e_day
            if (
              this.ufrom &&
              this.ufrom === 'user' &&
              this.plan.question &&
              this.plan.question.join &&
              (this.plan.question.join('').indexOf('损伤') !== -1 ||
                this.plan.question.join('').indexOf('疼痛') !== -1)
            ) {
              this.$dialog.alert({
                message:
                  '该会员身体有损伤(疼痛)，请认真查看本节课训练计划，同时阅读该会员的训练大纲!'
              })
            }
            // 格外提示弹窗
            // if (this.plan.tips && this.plan.tips.length) {
            //   this.showTips = true
            // }
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
          this.$toast.clear()
        })
        .catch((err) => {
          this.$dialog.alert({ message: '网络错误' })
          this.$toast.clear()
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    const { pid = '' } = to.query || {}
    if (pid && pid.indexOf(':') <= -1) {
      next({
        path: '/training-plan-show',
        query: to.query || {},
        replace: true
      })
    } else {
      next()
    }
  },
  created() {
    this.getPlan()
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.container {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  z-index: 14;
  text-align: left;
  background-color: #f7f7f7;
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(65);
  box-sizing: border-box;
  .nps-panel {
    width: 91.5vw;
    background-color: #ffffff;
    border-radius: 1.6vw;
    border: solid 0.3vw #f1f1f1;
    padding: 4.5vw 6vw;
    box-sizing: border-box;
    margin-top: 2.7vw;
  }
  .nps-top {
    .top-info {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info-left {
        text-align: left;
        flex: 1;
        .left-course {
          font-size: 5.3vw;
          font-weight: 600;
          span {
            color: #dc0050;
          }
        }
        .left-time {
          font-size: 3.7vw;
          color: rgba(0, 0, 0, 0.5);
          margin-top: 0.3vw;
        }
      }
      .info-img {
        width: 10.7vw;
        height: 10.7vw;
        border-radius: 50%;
        // background-color: #f1f1f1;
      }
    }
    .currprogress-region {
      width: 100%;
      box-sizing: border-box;
      height: 1.9vw;
      background: #d8d8d8;
      border-radius: 0.8vw;
      margin-top: 9.1vw;
      position: relative;
      .progress-pop {
        background-color: #fff;
        border: solid 1px #e7e7e7;
        border-radius: 1vw;
        padding: 0.3vw 2vw;
        box-sizing: border-box;
        font-size: 2.7vw;
        font-weight: 600;
        position: absolute;
        top: -7.5vw;
        left: 1%;
        transform: translateX(-50%);
        span {
          color: #dc0050;
        }
        .border-down-empty {
          content: '';
          width: 0;
          height: 0;
          // border-bottom: vw(10) solid transparent;
          // border-top: vw(10) solid #fff;
          // border-left: vw(10) solid transparent;
          // border-right: vw(10) solid transparent;
          // border: vw(1) solid #e7e7e7;
          position: absolute;
          bottom: vw(-5);
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: vw(5) solid transparent;
          border-right: vw(5) solid transparent;
          border-top: vw(5) solid #e7e7e7;
        }
        .border-down-empty span {
          display: block;
          width: 0;
          height: 0;
          border-left: vw(4.5) solid transparent;
          border-right: vw(4.5) solid transparent;
          border-top: vw(4.5) solid #fff;
          position: absolute;
          left: vw(-4.5);
          top: vw(-5);
        }
      }
      .progress {
        background-color: #dc0050;
        height: 100%;
        border-radius: 0.8vw;
        transition: width 1s ease-out;
        width: 1%;
      }
    }
    .progress-text {
      width: 100%;
      text-align: left;
      font-size: 3.2vw;
      box-sizing: border-box;
      margin-top: 1.5vw;
      display: flex;
      justify-content: space-between;
    }
  }
  .nps-position {
    .position-title {
      font-size: 4.3vw;
      font-weight: 600;
    }
    .position-item {
      display: flex;
      align-items: center;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 4vw;
      span {
        flex: 1;
        font-size: 3.5vw;
        color: #000;
        margin-left: 2.2vw;
        font-weight: 600;
      }
    }
    .position-item-1 {
      margin-top: 0;
    }
  }
  .nps-act {
    .act-title {
      font-size: 4.3vw;
      font-weight: 600;
    }
    .act-item {
      width: 100%;
      box-sizing: border-box;
      margin-top: 5.9vw;
      .item-title {
        display: flex;
        align-items: center;
        .t-dot {
          width: 3.2vw;
          height: 3.2vw;
          background-color: #ffffff;
          border: solid 0.8vw #dc0050;
          box-sizing: border-box;
          border-radius: 50%;
        }
        .t-text {
          flex: 1;
          font-size: 4vw;
          margin-left: 4vw;
          font-weight: 600;
          display: flex;
          align-items: center;
          .sub-t {
            font-size: 3.2vw;
            font-weight: 400;
            margin-left: 3vw;
          }
        }
      }
      .item-cent {
        position: relative;
        margin-left: 7.2vw;
        .cent-tag {
          margin-top: 0.8vw;
          color: rgba(0, 0, 0, 0.5);
          font-size: 3.2vw;
        }
        .cent-desc {
          background-color: #f7f7f7;
          border-radius: 1.1vw;
          border: solid 0.3vw #f1f1f1;
          margin-top: 2.7vw;
          font-size: 3.2vw;
          color: #000;
          padding: 1.1vw 3.2vw;
          box-sizing: border-box;
        }
      }
      .item-cent::after {
        content: '';
        height: 100%;
        border-left: dashed 0.5vw #dddddd;
        position: absolute;
        top: 0;
        left: -5.8vw;
      }
      .item-cent::before {
        content: '';
        border-left: solid 1.35vw transparent;
        border-top: solid 1.9vw #d8d8d8;
        border-right: solid 1.35vw transparent;
        border-bottom: solid 1.9vw transparent;
        position: absolute;
        bottom: -2.2vw;
        left: -6.9vw;
        z-index: 1;
      }
    }
  }
  .tips {
    background: rgba(229, 0, 73, 0.2);
    box-shadow: 0 0 0 0 #cccccc;
    text-align: center;
    width: 100%;
    // height: vw(28);
    // line-height: vw(29);
    color: #fff;
    font-size: vw(10);
    box-sizing: border-box;
    text-align: left;
    padding: vw(4) vw(10);
  }
  .hs-btn {
    width: vw(100/2);
    height: vw(100/2);
    border-radius: 50%;
    font-size: vw(28/2);
    font-weight: 450;
    // position: fixed;
    // right: vw(10);
    // bottom: vw(180);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ec7a9f;
  }
  header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    padding: vw(4) vw(12);
    position: relative;
    box-sizing: border-box;
    i {
      font-weight: 900;
      font-size: vw(20);
      padding: vw(5) vw(30);
    }
    .title {
      // font-weight: bold;
      color: #dc0050;
      font-size: vw(14);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .right {
      font-size: vw(15);
    }
  }
  .share-img {
    width: 0;
    // min-height: 100vh !important;
    position: absolute;
    // transform: rotate(180deg);
    top: 0;
    left: 0;
    transition: all 1.5s;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .on-share-img {
    width: 100vw;
    transform: rotate(360deg);
    transition: all 1.5s;
  }
  .header {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .user-ques {
      width: 100%;
      padding: 0 vw(28);
      box-sizing: border-box;
      font-size: vw(12);
      margin-top: vw(4);
      .q-item {
        padding-bottom: vw(4);
        border-bottom: vw(1) solid #f5f5f5;
        margin-top: vw(4);
      }
    }
    .progress-head {
      width: 100%;
      text-align: left;
      font-size: vw(12);
      margin-bottom: vw(8);
      padding: 0 vw(28);
      box-sizing: border-box;
    }
    .currprogress-region {
      width: vw(321);
      height: vw(6);
      // position: relative;
      background: #d8d8d8;
      // top: vw(1054);
      border-radius: vw(8/2);
      // left: vw(73);
      .progress {
        // position: absolute;
        // top: 50%;
        // left: 0;
        // transform: translateY(-50%);
        background-color: #dc0050;
        height: 100%;
        border-radius: vw(8/2);
        transition: width 1s ease-out;
        width: 1%;
      }
    }
    .progress-text {
      width: 100%;
      text-align: left;
      font-size: vw(12);
      // margin-bottom: vw(8);
      padding: 0 vw(28);
      box-sizing: border-box;
      margin-top: vw(4);
      display: flex;
      justify-content: space-between;
    }
  }
  .head-img {
    width: vw(48);
    height: vw(48);
    border-radius: 50%;
    margin-top: vw(15);
  }
  .name {
    font-size: vw(14);
    font-weight: 500;
    margin-top: vw(2);
  }
  .course {
    font-size: vw(14);
    font-weight: 500;
    // margin-bottom: vw(2);
    span {
      color: #dc0050;
      font-size: vw(26);
      margin: 0 vw(8);
    }
  }
  .top-time {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: vw(10);
    font-size: vw(10);
    .top-qishu {
      // background-color: #eaeaea;
      // border-radius: vw(13);
      font-size: vw(11);
      // padding: 0 vw(10);
      font-weight: 500;
      // margin-right: vw(5);
    }
  }
  .position-l {
    width: 100%;
    padding: vw(10) vw(24);
    padding-bottom: 0;
    margin-bottom: vw(10);
    background-color: #fff;
    box-sizing: border-box;
    .position-text {
      font-size: vw(15);
      font-weight: 600;
    }
    .position-desc {
      font-size: vw(12);
      color: #dc0050;
    }
  }
  .col {
    width: 100%;
    background-color: #fff;
    height: vw(40);
    line-height: vw(40);
    padding: 0 vw(15);
    box-sizing: border-box;
    font-size: vw(15);
    font-weight: 500;
    margin-bottom: vw(5);
    span {
      font-weight: 400;
    }
  }
  .panel {
    width: 100%;
    margin-bottom: vw(5);
    .title {
      font-size: vw(15);
      width: 100%;
      padding: 0 vw(15);
      box-sizing: border-box;
      height: vw(40);
      line-height: vw(41);
      font-weight: 600;
      text-align: left;
      background-color: #f5f5f5;
    }
    .aerobics-text {
      width: 100%;
      height: vw(44);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 vw(15);
      box-sizing: border-box;
      font-size: vw(15);
      font-weight: bold;
      background-color: #fff;
    }
    .act-item {
      width: 100%;
      background-color: #fff;
      padding: vw(10) vw(15);
      box-sizing: border-box;
      color: #4a4a4a;
      margin-bottom: vw(5);
      .act-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: vw(15);
        font-weight: 600;
        i {
          font-size: vw(18);
          color: #dc0050;
        }
      }
      .tags {
        font-size: vw(12);
        color: #9b9b9b;
        margin-top: vw(4);
        .number {
          color: #dc0050;
          font-weight: 500;
        }
      }
      .mode {
        background-color: #f5f5f5;
        padding: vw(5) vw(10);
        // color: #dc0050;
        font-weight: 600;
        font-size: vw(12);
        margin-top: vw(10);
      }
      .desc {
        background-color: #f5f5f5;
        padding: vw(5) vw(10);
        // font-weight: 600;
        font-size: vw(11);
        margin-top: vw(8);
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #fff;
    margin-top: 8vw;
    .f-right {
      display: flex;
      flex-direction: column;
      // align-items: center;
      text-align: left;
      img {
        width: 32.3vw;
        margin-top: 3.2vw;
      }
      .f-text {
        font-size: 3.2vw;
        color: #fff;
        text-align: center;
      }
    }
    #qrCode-canvas {
      width: 17.1vw !important;
      height: 17.1vw !important;
      margin-right: 3.7vw;
      // background-color: #f00;
    }
  }
  .footer-btn {
    width: 100%;
    background-color: #dc0050;
    height: vw(40);
    text-align: center;
    line-height: vw(41);
    color: #fff;
    font-size: vw(16);
    font-weight: bold;
    position: fixed;
    bottom: 0;
    z-index: 89;
  }
  .pop-tips {
    width: 85%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    box-sizing: border-box;
    padding: vw(32) vw(24);
    background-color: #fff;
    border-radius: vw(8);
    color: #000;
    text-align: left;
    z-index: 100;
    font-size: 3.5vw;
    color: #000;
    line-height: 6vw;
    .pop-close-btn {
      bottom: vw(-100);
    }
    .tips-item {
      display: flex;
      .i-left {
        margin-right: 2.7vw;
      }
      .i-right {
        // font-weight: 600;
      }
    }
    .tips-item + .tips-item {
      margin-top: 4vw;
    }
  }
}
.container-img {
  background-color: #dc0050;
  padding-bottom: vw(20);
  .nps-top {
    background-color: #dc0050;
    border: none;
    color: #fff !important;
    .left-course {
      span {
        color: #fff !important;
      }
    }
    .left-time {
      color: #fff !important;
    }
    .currprogress-region {
      background-color: #b6003a !important;
      .progress-pop {
        color: #000;
      }
      .progress {
        background-color: #fff !important;
      }
    }
  }
  .nps-position {
    margin-top: 0;
  }
}
</style>
